import React, { useContext, useEffect, useRef, useState } from 'react'
import mediapipe_pose_lite from '../assets/models/pose_landmarker_lite2.task';
import mediapipe_pose_full from '../assets/models/pose_landmarker_full.task'; 
import { PoseLandmarker, FilesetResolver, DrawingUtils } from "@mediapipe/tasks-vision";
import {drawConnectors, drawLandmarks } from '@mediapipe/drawing_utils/drawing_utils';

const PoserProviderContext = React.createContext();
export function usePoserProvider() {
    return useContext(PoserProviderContext)
}

export function PoserProvider({ children }) {

    const poseModel = useRef(null);
    const [statusPoser, setStatusPoser] = useState(false);
    const statusPoserRef = useRef(statusPoser);
    const poseDataRef = useRef(null);
    const bufferPoseDataRef = useRef(null);
    const arr_kps_HL = useRef([15, 17, 19, 21])
    const arr_kps_HR = useRef([16, 18, 20, 22])
    const arr_kps_HEAD = useRef([0, 2, 5, 7, 8, 9, 10])

    const initializePoser = async () => {
        console.log("🚀 ~ Poser ~ initializePoser:", initializePoser)
        poseModel.current = await PoseLandmarker.createFromOptions(await FilesetResolver.forVisionTasks("https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@latest/wasm"), {
            baseOptions: {
              modelAssetPath: mediapipe_pose_lite,
              delegate: "GPU"
            },
            numPoses: 1,
            runningMode: 'IMAGE'
        });
        statusPoserRef.current = true;
        console.log("🚀 ~ Segmenter ~ poseModel.current:", poseModel.current)
    };
    
    useEffect(() => {
        if (statusPoser){
            initializePoser();
        }
        else{
            poseModel.current = null
            statusPoserRef.current = false;
            poseDataRef.current = null
            bufferPoseDataRef.current = []
        }
    }, [statusPoser])

    async function applyPoseOnCanvas(streamImageBitmapRef, streamCanvasRef, streamContextRef){
        if (statusPoserRef.current){
            streamImageBitmapRef.current = await createImageBitmap(streamCanvasRef.current);
            poseDataRef.current = await poseModel.current.detect(streamImageBitmapRef.current);

            streamContextRef.current.fillStyle = 'purple';
            if (poseDataRef.current!== null) {

                // console.log("🚀 ~ MediapipeHolisticProvider ~ applyMediapipeHolisticOnCanvas ~ poseDataRef.current:", poseDataRef.current)
                // if (poseDataRef.current['landmarks'][0]!== undefined) {
                //     arr_kps_HL.current.forEach(index => {
                //         const point = poseDataRef.current['landmarks'][0][index];
                //         streamContextRef.current.fillRect(point.x * streamCanvasRef.current.width, point.y * streamCanvasRef.current.height, 3, 3);
                //     });
    
                //     arr_kps_HR.current.forEach(index => {
                //         const point = poseDataRef.current['landmarks'][0][index];
                //         streamContextRef.current.fillRect(point.x * streamCanvasRef.current.width, point.y * streamCanvasRef.current.height, 3, 3);
                //     });
    
                //     arr_kps_HEAD.current.forEach(index => {
                //         const point = poseDataRef.current['landmarks'][0][index];
                //         streamContextRef.current.fillRect(point.x * streamCanvasRef.current.width, point.y * streamCanvasRef.current.height, 3, 3);
                //     });
                // }

                // bufferPoseDataRef.current = [...bufferPoseDataRef.current, poseDataRef.current]
                bufferPoseDataRef.current = [...bufferPoseDataRef.current, poseDataRef.current].slice(-1000);
                
            }

            
        }else{
            console.log("🚀 ~ MediapipeHolisticProvider ~ applyMediapipeHolisticOnCanvas STEP EEROR  -- NO INICALIZADO:")
        }
        return Promise.resolve();
    }


    /* Exported values */
    const value = {
        statusPoser,
        setStatusPoser,
        statusPoserRef,
        applyPoseOnCanvas,
        poseDataRef,
        bufferPoseDataRef
    }

    return (
        <PoserProviderContext.Provider value={value}>
            {children}
        </PoserProviderContext.Provider>
    )
}